import {yupResolver} from '@hookform/resolvers/yup'
import {FC} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {formatDate} from '../../../../../util/dates'
import {CleaningStatusDto} from '../../../model/cleaningStatus.model'
import {cleaningStatusSchema} from '../../../schema/cleaningStatus'
import {CleaningStatusWrapper} from './form/CleaningStatus'

export const CleaningStatusPageWrapper: FC = () => {
  const methods = useForm<CleaningStatusDto>({
    resolver: yupResolver(cleaningStatusSchema),
    defaultValues: {
      CampamentoId: '',
      ServiceSchedulingId: '',
      FechaIni: formatDate(new Date()),
      FechaFin: formatDate(new Date()),
      //
      searching: false,
      searchNumber: 0,
      showModalProgrammingService: false,
      showModalProgrammingServiceDetails: false,
      showModalObservationDetails: false,
      observationId: null,
      cellData: null,
      observationNumber: 0,
      closedObservations: false,
    },
  })

  return (
    <FormProvider {...methods}>
      <CleaningStatusWrapper />
    </FormProvider>
  )
}
